import {
  Dispatch,
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';
import { DocumentPath } from './DocumentationButton/types';

type DocumentationLinkContextValue = {
  link: DocumentPath | null;
  setLink: Dispatch<DocumentPath | null>;
  clearLink: () => void;
  key: keyof typeof DocumentPath | null;
  setKey: Dispatch<keyof typeof DocumentPath | null>;
};
export const DocumentationLinkContext = createContext<DocumentationLinkContextValue | null>(null);

export const useDocumentationLinkContext = () => {
  const context = useContext(DocumentationLinkContext);
  if (!context) {
    console.warn('Cannot find DocumentationLinkContext');
  }
  return context;
};

export const DocumentationLinkProvider = ({ children }: PropsWithChildren<{}>) => {
  const [activeLink, setActiveLink] = useState<DocumentPath | null>(null);
  const [key, setKey] = useState<keyof typeof DocumentPath | null>(null);

  const clearLink = useCallback(() => {
    setActiveLink(null);
  }, []);

  return (
    <DocumentationLinkContext.Provider
      value={{
        link: activeLink,
        setLink: setActiveLink,
        clearLink,
        key,
        setKey,
      }}
    >
      {children}
    </DocumentationLinkContext.Provider>
  );
};
